import React from "react";
import { Figure, Container, Row, Col } from "react-bootstrap";
import Blogs from "../../components/Blogs/Blogs";
import Footer from "../../components/Footer/Footer";
import Projects from "../../components/Projects/Projects";
import { Skills } from "../../components/Skills/Skills";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  faGithub,
  faInstagram,
  faTwitter,
  faLinkedin,
} from "@fortawesome/free-brands-svg-icons";

import "./Homepage.css";
import heroImg from "./hero-img.jpeg";

const Homepage = () => {
  return (
    <>
      <Container className="hero-container" id="hero-section" fluid>
        <Row className="hero-row hero-img">
          <Figure>
            <Figure.Image
              width={250}
              height={250}
              className="profile-img"
              alt="Shrushti Polekar"
              src={heroImg}
            />
          </Figure>
        </Row>
        <Row className="hero-row hero-img">
          <h1 className="hero-text hero-text-primary">
            Hi there, I'm{" "}
            <span className="hero-text-primary highlight-text">
              Shrushti Polekar!
            </span>
          </h1>
          <div className="hero-text hero-text-secondary">
            <p>
              Frontend Developer with 3.5+ years of experience building
              scalable, component-driven React and React Native applications.
            </p>
            <p>
              Skilled in performance optimization, state management, and
              delivering seamless, user-centric web experiences.
            </p>
          </div>
        </Row>
        <Row></Row>
      </Container>
      <Projects />
      <Skills />
      <Blogs />
      <Footer />
    </>
  );
};

export default Homepage;
